<template>
    <div ref="monitor">
        <div id="chart">
            <apexchart type="area" height="350" ref="chart" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div>
            <v-data-table
                v-if="items.length > 0"
                :headers="headers"
                :items="items"
                hide-default-footer
                hide-default-header
                disable-pagination
                :height="heightTbl"
                @click:row="rowClick()" 
                class="elevation-1"
                item-key="name"
                fixed-header
            >
                <template
                    v-slot:header="{ props: { headers } }"
                >
                    <thead>
                        <tr>
                            <th v-for="item,ix in headers" 
                            >
                            <!-- :class="classBorderHdr(ix,item)" -->
                                {{item['text']}}
                            </th>
                        </tr>
                        <tr @click="rowClick(items[0])" class="firstRow">                                
                            <th>
                                {{ items[0].name }}
                            </th>
                            <th>
                                {{ items[0].time }}
                            </th>
                            <th>
                                {{ items[0].status }}
                            </th>
                            <th>
                                {{ items[0].wait }}
                            </th>
                            <th>
                                {{ items[0].count }}
                            </th>
                        </tr>                            
                    </thead>
                </template>
                <template
                    v-slot:body="{ items }"
                >
                    <tbody>    
                        <tr v-for="item,ix in items" v-if="ix > 0" @click="rowClick(item)">
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.time }}
                            </td>
                            <td>
                                {{ item.status }}
                            </td>
                            <td>
                                {{ item.wait }}
                            </td>
                            <td>
                                {{ item.count }}
                            </td>
                        </tr>
                    </tbody>
                </template>                
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
        name: 'Monitoring',
        components: {apexchart: VueApexCharts,},
        props: {
            height: {
                typeof: Number,
                require: true
            }
        },
        data() {
            return {
                series: [{
                    data: []
                }],
                chartOptions: {
                    chart: {
                        id: 'realtime',
                        height: 350,
                        type: 'line',
                    //colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                        animations: {
                            enabled: false,
                            easing: 'linear',
                            dynamicAnimation: {
                            speed: 1000
                            }
                        },
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        // curve: 'smooth'
                      curve: 'straight',
                      colors: [
                        //'#2E93fA',
                        '#66DA26',
                        //'#546E7A',
                        //'#E91E63',
                        //'#FF9800'
                      ],
                    },
                    title: {
                        text: 'All sessions',
                        align: 'left'
                    },
                    markers: {
                      size: 1
                    },
                    xaxis: {
                        categories: [0,1,2,3,4,5,6,7,9,10]
                    },
                    yaxis: {
                    },
                    legend: {
                        show: false
                    },
                },
                items: [
                    // {
                    //     name: 'All sessions',
                    //     time: '10',
                    //     status: 'active',
                    //     wait: '3',
                    //     count: '5',
                    //     data: [0, 3, 6, 9, 7, 10, 100, 20, 50, 60]
                    // },
                    // {
                    //     name: 'sessions 1',
                    //     time: '10',
                    //     status: 'active',
                    //     wait: '3',
                    //     count: '5',
                    //     data: [0, 5, 7, 3, 0, 20, 40, 70, 1000, 0]
                    // },
                ],
                headers: [
                    {
                        text: 'id сecии',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                        width: '160'          
                    },
                    { text: 'время(сек)', value: 'time', width: '160'},
                    { text: 'статус(активный, неактивный)', value: 'status' },
                    { text: 'ожидание', value: 'wait' },
                    { text: 'кол. запросов ( за последние 10 сек)', value: 'count' },
                ],
                intSec: null,
                int60: null,
                oldNum: null
            }
        },
        created() {
            // console.log('mounted',dataResp[0].data);
            let dataResp = [
                {
                    name: 'All sessions',
                    time: '10',
                    status: 'active',
                    wait: '3',
                    count: '5',
                    data: [0, 3, 6, 9, 7, 10, 100, 20, 50, 60]
                },
                {
                    name: 'sessions 1',
                    time: '1',
                    status: 'active',
                    wait: '4',
                    count: '3',
                    data: [0, 5, 7, 3, 0, 20, 40, 70, 1000, 0]
                },
                {
                    name: 'sessions 2',
                    time: '7',
                    status: 'active',
                    wait: '0',
                    count: '8',
                    data: [0, 5, 7, 3, 0, 20, 40, 70, 1000, 0]
                },
            ]
            this.items = dataResp
            this.series[0].data = dataResp[0].data
                       
            console.log('created', this.series.data);     
            let data = this.items[0].data
            let data2 = this.items[1].data            
            let data3 = this.items[2].data            
            this.intSec = setInterval(() => {
                if (!this.$refs.chart) {
                    clearInterval(this.intSec)
                    return
                }
                let categories = this.chartOptions.xaxis.categories
                // console.log('mounted intSec',categories);
                data.shift()
                data2.shift()
                data3.shift()
                categories.shift()
                const last = categories[categories.length - 1]
                categories.push(last + 1)
                function getRandomArbitrary(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                }
                data.push(getRandomArbitrary(0,100))
                data2.push(getRandomArbitrary(0,100))
                data3.push(getRandomArbitrary(0,100))
                this.$refs.chart.updateOptions({
                    xaxis: {
                        categories: categories
                    },
                    series: [{
                        data: this.series[0].data
                    }],
                })               
            }, 1000)
        },
        mounted() {
            // console.log('mounted', this.series);     
        },
        beforeUnmount() {
            clearInterval(this.intSec)
            clearInterval(this.int60)
        },
        computed: {
            heightTbl() {
                // console.log('heightTbl',this.$refs.monitor.clientHeight);                
                return this.height - 365 - 10
            }
        },
        methods: {
            rowClick(item) {
                // console.log('rowClick',item, this.$refs.title);
                // console.log('rowClick2', this.$refs.title);
                
                let colors = [
                    '#2E93fA',
                    '#66DA26',
                    '#546E7A',
                    '#E91E63',
                    '#FF9800'
                ]
                let max = 4  
                let min = 0  
                let num;
                let oldNum
                console.log('rowClick', this.oldNum);
                do {
                    num = Math.floor(Math.random() * (max - min + 1) + min);
                    console.log('rowClick3', this.oldNum);
                    console.log('rowClick2', num);
                } while (num == this.oldNum);
                this.oldNum = num
                this.series[0].data = item.data
                this.$refs.chart.updateOptions({
                    stroke: {
                        colors: [colors[num]]
                    },
                    title: {
                        text: item.name
                    },                    
                }) 
                // clearInterval(this.intSec)      
                // console.log('rowClick2', arr);
            }, 
        }
    }
</script>

<style lang="scss" scoped>
tr{
    &:hover {
        background: #eee !important;
    }
}
.firstRow {
    &:hover {
        th {         
            background: #eee !important;
        }
    }
}
.select {
    
}
.monStl {
    width: 100%;
    height: 100%
}
</style>
